<div #foxitPdfViewer class="ap-foxit-pdf-web-parent" style="width:100%;height:800px;"
(mousedown)="onMouseDown($event)"
(mouseup)="onMouseUp($event)">
</div>
